export type StammdatenPersonenstandEnum = '001' | '002' | '003' | '004' | '005' | '006' | '007';

export const StammdatenPersonenstandEnum = {
    _001: '001' as StammdatenPersonenstandEnum,
    _002: '002' as StammdatenPersonenstandEnum,
    _003: '003' as StammdatenPersonenstandEnum,
    _004: '004' as StammdatenPersonenstandEnum,
    _005: '005' as StammdatenPersonenstandEnum,
    _006: '006' as StammdatenPersonenstandEnum,
    _007: '007' as StammdatenPersonenstandEnum
};

